import React from 'react';
import { message } from 'antd'

import RandomizeFormSeparate from '../../components/RandomizeFormSeparate/RandomizeFormSeparate'
import { ResultsRandomization } from '../../components/Results/ResultsRandomization'

import { getRandomizationSites } from '../../api/requests';
import isAuthenticated from '../../utils/isAuthenticated';

import classes from './RandomizePage.css';
import {Helmet} from "react-helmet";

import { withNamespaces } from 'react-i18next';

class RandomizePageOld extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: '',
      studyID: '',
      dose: '',
      consentType: '',
      randomized: false,
      loading: false,
      sites: []
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this)
  }

  async componentDidMount() {
    try {
      const { data } = await getRandomizationSites();
      this.setState({ sites: data.filter(item => item.site_type === 'randomization') });
    } catch (e) { console.log(e); }
  }

  async handleSubmit(data) {

    this.setState({
      loading: true
    });

    this.setState({
      date: data.randomization_date,
      studyID: data.study_id,
      bottle_no: data.bottle_no,
      dose: data.dose,
      randomized: true,
      loading: false
    });
  }

  handleReset() {
    this.setState({
      date: '',
      studyID: '',
      dose: '',
      randomized: false,
      loading: false
    });
  }

  render() {
    const { loading, randomized, sites } = this.state;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }} className={classes.wrapper}>
        <Helmet>
          <title>{this.props.i18n.t('Trial Management Portal')}: {this.props.i18n.t('Dashboard')}</title>
        </Helmet>
        <div className={classes.parentContainer}>

          <div className={classes.content}>
            <h2>{this.props.i18n.t('Start Randomization')}</h2>
            <div style={{ display: randomized ? 'block' : 'none' }}><ResultsRandomization {...this.state} onBackClick={this.handleReset} /></div>

            {!randomized && <div>
              <RandomizeFormSeparate isEditableRandomize={true} sites={sites} loading={loading} handleSubmit={this.handleSubmit} />
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

export default isAuthenticated(withNamespaces()(RandomizePageOld));



// WEBPACK FOOTER //
// ./src/containers/RandomizePage/RandomizePageOld.js